import { createStore } from "vuex";
import audioPlayer from "@/modules/audioPlayer.store";
import songList from "@/modules/songList.store";
import auth from "@/modules/auth.store"

export default createStore({
    modules: {
        audioPlayer,
        songList,
        auth
    }
});

